import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import StockorderproductFilterCriteria from './StockorderproductFilterCriteria'
import StockorderproductListImpl from './StockorderproductListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './StockorderproductAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setStockorderproductDashboardStockorderproductList } from '../../store/slice/ManufSlice';

export default function StockorderproductListView({setShowEdit,setStockorderproductId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.stockorderproductDashboard);   

    const [filteredStockorderproductList, setFilteredStockorderproductList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { stockorderproductDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (stockorderproductDashboard.stockorderproductList.length>-1){
        setFilteredStockorderproductList(stockorderproductDashboard.stockorderproductList);
        transformToCardFormat(stockorderproductDashboard.stockorderproductList, setCardList);
      }
    },[stockorderproductDashboard.stockorderproductList])

    useEffect(()=>{
          transformToCardFormat(filteredStockorderproductList, setCardList);
      },[filteredStockorderproductList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.productid==='' && filterCriteria.productname==='' && filterCriteria.qty==='' && filterCriteria.matter==='' && filterCriteria.deliverypriorityid==='' && filterCriteria.deliverypriorityname==='' && filterCriteria.expecteddelivery==='' && filterCriteria.printingtype==='' && filterCriteria.stitchingtype==='' && filterCriteria.withprinting==='' && filterCriteria.stockorderid==='' && filterCriteria.receivedqty==='' && filterCriteria.statusid==='' && filterCriteria.statusname==='' && filterCriteria.remarks==='' && filterCriteria.stitchingworkerid==='' && filterCriteria.stitchingworkername==='' && filterCriteria.stitchingrate==='' ){
            setFilteredStockorderproductList(stockorderproductDashboard.stockorderproductList);
            transformToCardFormat(stockorderproductDashboard.stockorderproductList, setCardList);

        } else {
            setFilteredStockorderproductList(
                stockorderproductDashboard.stockorderproductList
                    .filter(stockorderproduct=> stockorderproduct.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(stockorderproductDashboard.filteredStockorderproductList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <StockorderproductListImpl
                    setShowEdit={setShowEdit}
                    setStockorderproductId = {setStockorderproductId}
                    tableList={filteredStockorderproductList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}